import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { InformationState } from "@redotech/redo-return-ui/flows/return-flow/information";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const InformationDetails = memo(function InformationDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<InformationState>) {
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );
  return (
    <>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Title
        </Text>
        <RedoTextInput
          placeholder="Enter title..."
          setValue={(header) => setState((state) => ({ ...state, header }))}
          state={canEditReturnsSettings ? "default" : "readonly"}
          value={state.header}
        />
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          Title to show to the customer.
        </Text>
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Message
        </Text>
        <RedoTextareaInputField
          placeholder="Enter message..."
          readOnly={!canEditReturnsSettings}
          setValue={(message) => setState((state) => ({ ...state, message }))}
          value={state.message}
        />
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          Message to show to the customer. Can include HTML.
        </Text>
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Continue Button Text
        </Text>
        <RedoTextInput
          placeholder="Enter button text..."
          setValue={(continueButtonText) =>
            setState((state) => ({ ...state, continueButtonText }))
          }
          state={canEditReturnsSettings ? "default" : "readonly"}
          value={state.continueButtonText}
        />
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          Text to show on the continue button.
        </Text>
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Next step
        </Text>
        {stepSelect({
          value: state.next,
          valueChange: (next) => setState((state) => ({ ...state, next })),
          handleIndex: 0,
        })}
        {!state.next && (
          <Text fontSize="xs" textColor="error">
            Required
          </Text>
        )}
      </Flex>
    </>
  );
});
